var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconPapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07227 5.08091V34.3989C4.07227 34.721 4.33332 34.9821 4.65537 34.9821H25.8109C26.1327 34.9821 26.3938 34.721 26.3938 34.3989V9.79445C26.3938 9.78148 26.3875 9.77043 26.3863 9.7577C26.3835 9.70655 26.3734 9.65612 26.3566 9.60784C26.3501 9.58911 26.3455 9.5711 26.3374 9.55285C26.309 9.48945 26.2696 9.43157 26.2206 9.3821L20.7627 4.6688C20.7132 4.61957 20.6551 4.58018 20.5912 4.55208C20.5736 4.54464 20.5559 4.53839 20.5376 4.53287C20.4889 4.51606 20.4382 4.50597 20.3866 4.50261C20.3767 4.50429 20.3652 4.49805 20.3529 4.49805H4.65537C4.33332 4.49805 4.07227 4.75886 4.07227 5.08091ZM24.031 10.3284H19.8188V6.86082L24.031 10.3284ZM6.35525 6.78104H17.5358V12.0285C17.5358 12.3503 17.7969 12.6114 18.1187 12.6114H24.1108V32.6991H6.35525V6.78104Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8152 29.201V31.484H30.309C30.631 31.484 30.8921 31.2232 30.8921 30.9012V0.583104C30.8921 0.261052 30.631 0 30.309 0H8.15342C7.83136 0 7.57031 0.261052 7.57031 0.583104V3.07686H10.5982V2.28299H28.2365L28.6089 29.201H27.8152Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12H13V13H9V12Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16H18V17H9V16Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16H22V17H19V16Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20H22V21H9V20Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 28H22V29H9V28Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 24H22V25H14V24Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 24H13V25H9V24Z",
    fill: "#D59B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPapper);
export default __webpack_public_path__ + "static/media/menu-icon-papper.7d6931e55242ec829f98266d70f7d345.svg";
export { ForwardRef as ReactComponent };